(function () {
  'use strict';

  angular.module('ringbaPortal').component('notificationMessageList', {
    bindings: {
      loading: '<',
      messages: '<',
      selectedMessageId: '<',
      totalMessageCount: '<',
      onMessageSelected: '<',
      onShowMoreMessages: '<',
      onClearSelectedMessage: '<',
      emptyMessage: '@'
    },
    controller: notificationMessageListController,
    controllerAs: 'vm',
    templateUrl: '/scripts/shared/components/in-app-notifications/notification-message-list.view.html'
  });

  function notificationMessageListController(
    _,
    moment
  ) {
    'ngInject';

    const vm = this;

    vm.$onInit = onInit;
    vm.$onChanges = onChanges;
    vm.clearSelectedMessage = clearSelectedMessage;
    vm.selectMessage = selectMessage;
    vm.showMoreMessages = showMoreMessages;


    function onInit() {
      clearSelectedMessage();
      _updateMoreMessagesAvailable();
    }

    function onChanges(changesObj) {
      if ((changesObj.totalMessageCount && changesObj.totalMessageCount.currentValue) || changesObj.messages) {
        _updateMoreMessagesAvailable();
      }
      if (changesObj.selectedMessageId && changesObj.selectedMessageId.currentValue) {
        _selectMessageById(vm.selectedMessageId);
      }
    }

    function selectMessage(message) {
      vm.selectedMessage = message;
      const createTimestamp = moment.utc(vm.selectedMessage.create_time);
      vm.messageTimestamp = (moment().diff(createTimestamp) / 1000 / 60 / 60 / 24) > 1 ? createTimestamp.format('MMM D, YYYY h:mmA') : createTimestamp.fromNow();
      if (vm.onMessageSelected) {
        vm.onMessageSelected(message.id);
      }
    }

    function clearSelectedMessage(forceClear) {
      if (forceClear || !vm.selectedMessageId) {
        vm.selectedMessage = false;
        if (vm.onClearSelectedMessage) {
          vm.onClearSelectedMessage();
        }
      }
    }

    function showMoreMessages() {
      if (vm.onShowMoreMessages) {
        vm.onShowMoreMessages();
      }
      _updateMoreMessagesAvailable();
    }

    function _updateMoreMessagesAvailable() {
      vm.moreMessagesAvailable = vm.messages && vm.totalMessageCount && vm.messages.length < vm.totalMessageCount;
    }

    function _selectMessageById(messageId) {
      const messageSelected = _.find(vm.messages, {
        id: messageId
      });
      if (messageSelected) {
        selectMessage(messageSelected);
      }
    }
  }
})();
